export default "__VITE_ASSET__Bhm7EcgF__"